export default [{
	path: '/InteractiveCourse',
	component: () => import('../../views/platform/interactiveCourse/index'),
	redirect: '/InteractiveCourse/course',
	children: [
		{
			path: 'course',
			component: () => import('../../views/platform/interactiveCourse/course')
		},
		{
			path: 'study',
			component: () => import('../../views/platform/interactiveCourse/study')
		}
	]
}]